import { render, staticRenderFns } from "./lead-projection-results.vue?vue&type=template&id=63a0f6ae&scoped=true"
import script from "./lead-projection-results.vue?vue&type=script&lang=js"
export * from "./lead-projection-results.vue?vue&type=script&lang=js"
import style0 from "./lead-projection-results.vue?vue&type=style&index=0&id=63a0f6ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a0f6ae",
  null
  
)

export default component.exports